import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["aria-describedby", "aria-invalid"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["disabled", "aria-busy"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('modal-backdrop') + ' ' + _ctx.getClass('modal-backdrop--custom'))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('modal') + ' ' + _ctx.getClass('modal--custom')),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Submit Feedback modal",
      "aria-describedby": "feedbackModalDescription"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('modal-header'))
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { "aria-hidden": "true" }, " ", -1 /* HOISTED */)),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.getClass('btn-close')),
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          title: "Close",
          ref: "closeButton",
          disabled: _ctx.isSubmitting
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* HOISTED */)
        ]), 10 /* CLASS, PROPS */, _hoisted_1)
      ], 2 /* CLASS */),
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.getClass('modal-body') + ' ' + _ctx.getClass('modal-body--custom')),
        id: "feedbackModalDescription"
      }, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.submitFeedback && _ctx.submitFeedback(...args)), ["prevent"])),
          class: _normalizeClass(_ctx.getClass('form-inline'))
        }, [
          _createElementVNode("div", {
            id: "FeedbackForm",
            class: _normalizeClass(_ctx.getClass('feedback-form ') + _ctx.getClass('modal-form'))
          }, [
            _createCommentVNode(" Row 1 "),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center ') + _ctx.getClass('lh-1'))
            }, [
              _createElementVNode("label", {
                for: "feedbackText",
                class: _normalizeClass(_ctx.getClass('small-text ') + _ctx.getClass('lh-1')),
                ref: "formHeadingLine"
              }, "Tell us more...", 2 /* CLASS */)
            ], 2 /* CLASS */),
            _createElementVNode("span", {
              id: "feedbackHint",
              class: _normalizeClass(_ctx.getClass('visually-hidden')),
              ref: "feedbackHint"
            }, "Please help us understand how we can improve", 2 /* CLASS */),
            _createCommentVNode(" Row 2 "),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row'))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-element '))
              }, [
                _withDirectives(_createElementVNode("textarea", {
                  id: "feedbackText",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.feedbackText) = $event)),
                  class: _normalizeClass(_ctx.getClass('form-input ') + _ctx.getClass('form-textarea ')),
                  placeholder: "Please help us understand how we can improve.",
                  autocomplete: "off",
                  "aria-required": "true",
                  "aria-describedby": _ctx.feedbackAriaDescribedBy,
                  "aria-invalid": !!_ctx.errorMessage,
                  rows: "5",
                  maxlength: "5000",
                  ref: "feedbackText"
                }, null, 10 /* CLASS, PROPS */, _hoisted_2), [
                  [
                    _vModelText,
                    _ctx.feedbackText,
                    void 0,
                    { trim: true }
                  ]
                ])
              ], 2 /* CLASS */)
            ], 2 /* CLASS */),
            _createCommentVNode(" Quick reply buttons "),
            (_ctx.feedbackDownButtonLabels && _ctx.feedbackDownButtonLabels.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('quick-replies'))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('quick-buttons ')),
                    role: "list"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbackDownButtonLabels, (label, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: index,
                        type: "button",
                        role: "listitem",
                        class: _normalizeClass(_ctx.getClass('quick-reply-btn ')),
                        onClick: $event => (_ctx.handleQuickReply(label))
                      }, _toDisplayString(label), 11 /* TEXT, CLASS, PROPS */, _hoisted_3))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" General Error Message "),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.getClass('form-row'))
                }, [
                  _createElementVNode("div", {
                    id: "feedbackError",
                    class: _normalizeClass(_ctx.getClass('gen-error-message')),
                    role: "alert",
                    "aria-live": "assertive",
                    "aria-atomic": "true"
                  }, _toDisplayString(_ctx.errorMessage), 3 /* TEXT, CLASS */)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Success Message "),
            (_ctx.successMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(_ctx.getClass('form-row'))
                }, [
                  _createElementVNode("div", {
                    id: "feedbackSuccess",
                    class: _normalizeClass(_ctx.getClass('gen-success-message')),
                    role: "alert",
                    "aria-live": "assertive",
                    "aria-atomic": "true"
                  }, _toDisplayString(_ctx.successMessage), 3 /* TEXT, CLASS */)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Action buttons "),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('pb-0 '))
            }, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(_ctx.getClass('btn-transcript ') + _ctx.getClass('btn-block ')),
                disabled: !_ctx.canSubmit,
                "aria-busy": _ctx.isSubmitting
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.buttonText), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_4)
            ], 2 /* CLASS */)
          ], 2 /* CLASS */)
        ], 34 /* CLASS, NEED_HYDRATION */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}